import { actions as GLOBAL_MODALS } from "@src/Actions/Reducers/GlobalModalsReducer"
import Dialog from "@src/Components/Dialog"
import { Link } from "@src/Components/Link"
import { Section } from "@src/Components/StyledUtils"
import { tState } from "@src/Model/Model"
import { updateCustomerPortalData } from "@src/Sagas"
import { Button } from "@zeguro/component-library"
import * as React from "react"
import { useDispatch, useSelector } from "react-redux"

import featuresCfg from "./IntroDialogCfg"
import {
  Body,
  ButtonSpacer,
  Container,
  Counter,
  Footer,
  Header,
  HeaderImg,
  Text,
  Title,
} from "./styles"

interface IIntroDialog {
  isOpen: boolean
}

const IntroDialog = ({ isOpen }: IIntroDialog) => {
  const dispatch = useDispatch()
  const isZeguroServiceSession = useSelector(
    (state: tState) => state.portal.isZeguroServiceSession,
  )
  const { openedFeature, currentPage } = useSelector(
    (store: tState) => store.globalModals.introModalState,
  )
  const customerPortalData = useSelector(
    (store: tState) => store.customerPortalData,
  )
  const introViewed = customerPortalData.data?.introViewed
  const isLoading = customerPortalData.updateCustomerPortalData.isLoading

  const isIntroDialogEmpty = !openedFeature || openedFeature === "dashboard"
  React.useEffect(() => {
    if (
      openedFeature &&
      !isZeguroServiceSession &&
      !introViewed?.[openedFeature] &&
      !isLoading
    ) {
      dispatch(
        updateCustomerPortalData({
          introViewed: { [openedFeature]: true },
        }),
      )
    }
  }, [isLoading, isZeguroServiceSession, introViewed, openedFeature])

  if (isIntroDialogEmpty) {
    return null
  }

  const pageNum = featuresCfg[openedFeature].length
  const feature = featuresCfg[openedFeature][currentPage - 1]

  const onClose = () => dispatch(GLOBAL_MODALS.changeIntroModal(null))
  const onChangePage = (pageNum: number) =>
    dispatch(GLOBAL_MODALS.changeIntroModalPage(pageNum))

  return (
    <Dialog className="zeg-intro" isOpen={isOpen} onClose={() => {}}>
      <Body>
        <Header>
          <HeaderImg src={feature.imageSrc} />
        </Header>
        <Container>
          <Title>{feature.title}</Title>
          <Text>{feature.text}</Text>
          <Footer alignItems={pageNum === 1 ? "flex-end" : ""}>
            <Section>
              {currentPage === 1 ? (
                <ButtonSpacer />
              ) : (
                <Button
                  variant="secondary"
                  onClick={() =>
                    currentPage > 1 ? onChangePage(currentPage - 1) : onClose()
                  }
                  width="100px"
                >
                  Back
                </Button>
              )}
              <Counter hidden={pageNum < 2}>
                {currentPage} of {pageNum}
              </Counter>
              <Button
                variant="primary"
                width="100px"
                onClick={() => {
                  if (currentPage === pageNum) {
                    onClose()
                    return
                  }
                  if (currentPage < pageNum) {
                    onChangePage(currentPage + 1)
                  } else {
                    onClose()
                  }
                }}
              >
                {currentPage < pageNum ? "Next" : "Got It"}
              </Button>
            </Section>
            <Section padding="10 0 0 0">
              {currentPage !== pageNum && (
                <Button variant="tertiary" onClick={onClose}>
                  Skip Intro
                </Button>
              )}
            </Section>
          </Footer>
        </Container>
      </Body>
    </Dialog>
  )
}

export default IntroDialog
